export default {
  subscription: 'Abonnement',
  subscriptions: 'Abonnements',
  'subscription.feature': 'Funktion',
  'subscription.features': 'Funktionen',
  'subscription.select': 'Auswählen',
  'subscription.selected': 'Ausgewählt',
  'subscription.title': 'Titel',
  'subscription.duration': 'Zahlungsdauer',
  'subscription.sale': 'Sale-Informationen',
  'subscription.saleStart': 'Gestartet am',
  'subscription.saleEnd': 'Abgelaufen am',
  'subscription.discount': 'Rabatt',
  'subscription.discountInfo': 'Rabatt {discount}',
  'subscription.info': 'Abonnement-Info',
  'subscription.price': 'Preis',
  'subscription.notice': 'Hinweis',
  'subscription.users': 'Maximale Anzahl Geschäftsbenutzer',
  'subscription.usersInfo': 'Bis zu {{users}} Benutzer',
  'subscription.actions.edit': 'Abonnements bearbeiten',
  'subscription.actions.addNew': 'Neues Abonnement hinzufügen',
  'subscription.actions.manage': 'Abonnements verwalten',
  'subscription.msg.deleteConfirm':
    'Möchten Sie dieses Abonnement wirklich löschen',
  'subscription.tags': 'Tags',
  'subscription.assigned.features': 'Zugewiesene Funktionen ({{count}})',
  'subscription.features.helper':
    'Um ein Abonnement zu erstellen, müssen Sie mindestens eine Funktion zuweisen. Funktionen definieren die im Abonnement enthaltenen Fähigkeiten. Bitte wählen Sie Funktionen aus der verfügbaren Liste oder erstellen Sie zunächst neue.',
  'subscription.msg.unAssignConfirm':
    'Möchten Sie die Zuweisung dieser Funktion wirklich aufheben?',
  'subscription.msg.unAssignAllConfirm':
    'Möchten Sie die Zuweisungen aller Funktionen wirklich aufheben?',
  'subscription.msg.deactivateBlocked': 'Deaktivierung blockiert',
  'subscription.msg.deactivateBlockedDescription':
    'Sie können dieses Abonnement nicht deaktivieren, da es bereits für {{tenantName}} verwendet wird.',
  'subscription.actions.navigateToTenant': 'Zum Mandanten navigieren',
};
